import React from 'react';
import { Switch, Route} from 'react-router-dom';

import SupplierProduct from './SupplierProductsForm';
import CustomerFavSupplierProductList from './CustomerFavSupplierProductsList' 


const FavSupplierProducts = () => (
  <Switch>
    <Route
      exact
      component={CustomerFavSupplierProductList}
      path='/supplier-fav-products'
    />
    <Route
      exact
      component={SupplierProduct}
      path='/supplier-fav-products/:id'
    />
  </Switch>
);

export default FavSupplierProducts;